'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_AfterLoginResponse$RegisteredData(id, details, prefs, kind) {
  this.Kj = null;
  this.Ki = null;
  this.Kk = null;
  this.Xd = null;
  this.Kj = id;
  this.Ki = details;
  this.Kk = prefs;
  this.Xd = kind;
}
export { $c_Lapp_api_AfterLoginResponse$RegisteredData as $c_Lapp_api_AfterLoginResponse$RegisteredData };
$p = $c_Lapp_api_AfterLoginResponse$RegisteredData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_AfterLoginResponse$RegisteredData;
/** @constructor */
function $h_Lapp_api_AfterLoginResponse$RegisteredData() {
}
export { $h_Lapp_api_AfterLoginResponse$RegisteredData as $h_Lapp_api_AfterLoginResponse$RegisteredData };
$h_Lapp_api_AfterLoginResponse$RegisteredData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_AfterLoginResponse$RegisteredData)) {
    var x = this.Kj;
    var x$2 = x$0.Kj;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Ki;
      var x$4 = x$0.Ki;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Kk;
      var x$6 = x$0.Kk;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Xd;
      var x$8 = x$0.Xd;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 4;
});
$p.t = (function() {
  return "RegisteredData";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.Kj;
      break;
    }
    case 1: {
      return this.Ki;
      break;
    }
    case 2: {
      return this.Kk;
      break;
    }
    case 3: {
      return this.Xd;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "details";
      break;
    }
    case 2: {
      return "prefs";
      break;
    }
    case 3: {
      return "kind";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_AfterLoginResponse$RegisteredData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.id)));
}
export { $isArrayOf_Lapp_api_AfterLoginResponse$RegisteredData as $isArrayOf_Lapp_api_AfterLoginResponse$RegisteredData };
var $d_Lapp_api_AfterLoginResponse$RegisteredData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_AfterLoginResponse$RegisteredData, "app.api.AfterLoginResponse$RegisteredData", ({
  id: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_AfterLoginResponse$RegisteredData as $d_Lapp_api_AfterLoginResponse$RegisteredData };
//# sourceMappingURL=app.api.-After-Login-Response$-Registered-Data.js.map
